'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { MlRecommendationTracking } from '@/types/tracking/ml-recommendation';

const MlRecommendationContext = createContext<MlRecommendationTracking | null>(null);

type MlRecommendationProviderProps = {
    value: MlRecommendationTracking | null;
    children: ReactNode;
};

export const MlRecommendationProvider = ({ value, children }: MlRecommendationProviderProps) => (
    <MlRecommendationContext.Provider value={value}>{children}</MlRecommendationContext.Provider>
);

export const useMlRecommendationContext = () => useContext(MlRecommendationContext);
